import React from "react";
import {
  Clock3,
  Laptop,
  GraduationCap,
  CalendarCheck,
  BadgeCheck,
  Headphones,
  Code2,
  BriefcaseBusiness,
} from "lucide-react";

function AboutInternship() {
  const highlights = [
    { icon: Clock3, title: "Duration", value: "4 to 8 Weeks" },
    { icon: Laptop, title: "Mode", value: "Online / Offline" },
    {
      icon: GraduationCap,
      title: "Eligibility",
      value: "All Polytechnic Students",
    },
    { icon: CalendarCheck, title: "Start", value: "Start Anytime" },
    { icon: BadgeCheck, title: "Certificate", value: "Certificate Provided" },
    { icon: Headphones, title: "Support", value: "24/7 Mentor Support" },
    { icon: Code2, title: "Projects", value: "Live Project Training" },
    { icon: BriefcaseBusiness, title: "Career", value: "Placement Assistance" },
  ];

  return (
    <section className="bg-white dark:bg-[#050505] py-20 px-6 lg:px-16">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-3 gap-10 items-start">
        {/* ABOUT CONTENT */}
        <div className="lg:col-span-2">
          <p className="text-primary text-sm font-semibold uppercase mb-2">
            About Us
          </p>

          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-6">
            About Our Polytechnic Internship Program in Jodhpur
          </h2>

          <div className="space-y-5 text-gray-700 dark:text-gray-300 leading-8">
            <p>
              Web X Secure offers a practical Polytechnic Internship Program in
              Jodhpur for students who want to build real industry skills while
              studying. This program is designed for all polytechnic branches
              and focuses on hands-on learning, live projects, technical
              mentorship, and career-oriented training.
            </p>

            <p>
              During the internship, students learn modern technologies such as
              web development, digital marketing, AI tools, programming, project
              management, software workflows, and professional communication.
              Our goal is to help students understand how real companies work
              and how technical projects are planned, developed, tested, and
              delivered.
            </p>

            <p>
              The internship is suitable for Computer Engineering, Information
              Technology, Civil, Mechanical, Electrical, Electronics,
              Automobile, Chemical, Petroleum, and AI & ML students. Each
              student gets guidance according to their branch, interest, and
              career goal.
            </p>

            <p>
              With live project training, mentor support, certificate, and
              placement assistance, this internship helps students become more
              confident, skilled, and industry-ready.
            </p>
          </div>
        </div>

        {/* PROGRAM HIGHLIGHTS */}
        <div className="rounded-2xl border border-gray-200 dark:border-white/10 bg-white dark:bg-white/5 p-7 shadow-lg">
          <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-7">
            Program Highlights
          </h3>

          <div className="grid grid-cols-1 gap-5">
            {highlights.map((item, index) => {
              const Icon = item.icon;

              return (
                <div key={index} className="flex items-center gap-4">
                  <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary">
                    <Icon className="w-5 h-5" />
                  </div>

                  <div>
                    <h4 className="text-sm font-bold text-gray-900 dark:text-white">
                      {item.title}:{" "}
                      <span className="font-semibold text-gray-700 dark:text-gray-300">
                        {item.value}
                      </span>
                    </h4>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutInternship;
